import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnInit,
    signal,
    computed,
    ChangeDetectionStrategy,
    ViewChild,
} from "@angular/core";

import { TypeManagerDecorator } from "../../main/type.map.service";
import { IngestionFieldDefinition } from "../data-ingestion/data.ingestion.service";
import { WorkflowJsonPayloadBuilderComponent } from "./workflow.json.payload.builder.component";
import { S25ModalModule } from "../s25-modal/s25.modal.module";
import { S25ModalComponent } from "../s25-modal/s25.modal.component";

@TypeManagerDecorator("workflow-json-payload-builder-modal")
@Component({
    selector: "workflow-json-payload-builder-modal",
    template: `
        <s25-ng-modal #modal title="JSON Payload Builder" size="xxl" type="custom" (modalClosed)="onModalClosed()">
            <ng-template #s25ModalBody>
                <workflow-json-payload-builder
                    [availableFields]="availableFields"
                    [initialPayload]="initialPayload"
                    (payloadChange)="onPayloadChange($event)"
                    (payloadSave)="onPayloadSave($event)"
                ></workflow-json-payload-builder>
            </ng-template>

            <ng-template #s25ModalFooter>
                <div class="modal-footer-actions">
                    <button type="button" class="aw-button aw-button--outline" (click)="closeModal()">Cancel</button>
                    <button type="button" class="aw-button aw-button--primary" (click)="saveAndClose()">
                        Save & Close
                    </button>
                </div>
            </ng-template>
        </s25-ng-modal>
    `,
    styles: `
        .modal-footer-actions {
            display: flex;
            gap: 10px;
            justify-content: flex-end;
            padding: 16px;
        }

        ::ng-deep .s25-modal--body {
            padding: 0;
            overflow: hidden;
        }

        ::ng-deep .payload-builder {
            height: 80vh;
            border: none;
            border-radius: 0;
        }

        ::ng-deep .builder-content {
            height: calc(80vh - 120px);
        }

        ::ng-deep .json-editor {
            height: 100%;
        }

        ::ng-deep .json-textarea {
            height: calc(100% - 40px);
            min-height: 400px;
        }

        ::ng-deep .field-picker,
        ::ng-deep .function-picker {
            height: 100%;
            overflow-y: auto;
        }
    `,
    standalone: true,
    imports: [WorkflowJsonPayloadBuilderComponent, S25ModalModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkflowJsonPayloadBuilderModalComponent implements OnInit {
    @Input() availableFields: IngestionFieldDefinition[] = [];
    @Input() initialPayload: string = "";

    @Output() payloadChange = new EventEmitter<string>();
    @Output() payloadSave = new EventEmitter<string>();
    @Output() modalClosed = new EventEmitter<void>();

    @ViewChild("modal") modal!: S25ModalComponent;

    currentPayload = signal("");

    ngOnInit() {
        this.currentPayload.set(this.initialPayload);
    }

    openModal() {
        this.currentPayload.set(this.initialPayload);
        return this.modal.open({
            title: "JSON Payload Builder",
            size: "xxl",
            type: "custom",
        });
    }

    closeModal() {
        this.modal.close();
    }

    onPayloadChange(payload: string) {
        this.currentPayload.set(payload);
        this.payloadChange.emit(payload);
    }

    onPayloadSave(payload: string) {
        this.payloadSave.emit(payload);
    }

    saveAndClose() {
        this.payloadSave.emit(this.currentPayload());
        this.closeModal();
    }

    onModalClosed() {
        this.modalClosed.emit();
    }
}
